import React, { useState, useEffect } from 'react';
import Chat from '../components/Chat/Chat';
import FooterHome from '../components/Homepage/FooterHome';
import HeaderHome from '../components/Homepage/HeaderHome';

const LayoutHomepage = ({ children }) => {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    setPath(window.location.pathname);
  }, [window.location.pathname]);
  return (
    <>
      <HeaderHome />
      <div className=" bg-background-white flex">{children}</div>
      {path === '/welcome' ? null : <FooterHome />}
      <Chat />
    </>
  );
};

export default LayoutHomepage;
